import { RootState } from "../reducers";

export const getSubmitRequestStatus = (state: RootState) => state.submitRequest?.success;

export const getReadyToSubmitRescue = (state: RootState): boolean => {
  return state?.readyToSubmitRescue?.readyToSubmit;
};
